export const getToast = (state) => state.common.toast;
export const getLoader = (state) => state.common.isLoading;
export const getSalesForm = (state) => state.common.salesDataForm;
export const getProjectChange = (state) => state.common.changeProject;
export const getIsMicrosoftLogin = (state) => state.common.isMicrosoftLogin;
